import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useFieldArray, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { FloatSelect, WizardFooter } from "src/componentes";
import {
  getLocal,
  MDFeInput,
  STORAGEMDFE_KEY,
  ufOptions,
  updateLocal,
} from "../MDFe.Dto";
import { PercursoFormType, PercursoSchema } from "./MDFe.Cadastro.Dto";

const MDFeCadastroPercursoView = () => {
  const navigate = useNavigate();
  const mdfe = getLocal<MDFeInput>(STORAGEMDFE_KEY);

  const form = useForm<PercursoFormType>({
    resolver: yupResolver(PercursoSchema),
    defaultValues: {
      percursos: mdfe?.percursos && mdfe.percursos.length > 0 ? mdfe.percursos : [],
    },
  });

  const { fields, append, remove } = useFieldArray({
    control: form.control,
    name: "percursos",
  });

  const handleVoltar = () => {
    navigate("../identificacao");
  };

  const onSubmit = (data: PercursoFormType) => {
    const percursosLimpos = (data.percursos || []).map((p, idx) => ({
      ufPercurso: p.ufPercurso,
      sequencia: idx + 1,
    }));

    updateLocal<MDFeInput>(STORAGEMDFE_KEY, {
      percursos: percursosLimpos.length > 0 ? percursosLimpos : undefined,
    });

    navigate("../veiculo");
  };

  return (
    <Form noValidate onSubmit={form.handleSubmit(onSubmit)} className="mt-3 mb-5">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h5 className="text-primary mb-0">UFs de Percurso (Passagem)</h5>
          <small className="text-muted">
            Obrigatório apenas se as UFs de início ({mdfe?.ufInicio || "-"}) e fim (
            {mdfe?.ufFim || "-"}) não forem limítrofes/vizinhas.
          </small>
        </div>
        <Button
          variant="outline-primary"
          size="sm"
          onClick={() =>
            append({
              ufPercurso: "PR",
              sequencia: fields.length + 1,
            })
          }
        >
          + Adicionar UF
        </Button>
      </div>

      {fields.length === 0 ? (
        <div className="text-muted py-4 text-center">
          Nenhuma UF de percurso informada. Caso a viagem seja direta entre UFs vizinhas, clique em "Próximo".
        </div>
      ) : (
        fields.map((field, index) => (
          <div key={field.id} className="mb-3">
            <Row className="g-3 align-items-center">
              <Col xs={12} sm={3} md={2}>
                <span className="fw-bold text-secondary">
                  Passo #{index + 1}
                </span>
              </Col>
              <Col xs={9} sm={7} md={8}>
                <FloatSelect
                  label={`UF de Passagem #${index + 1}`}
                  options={ufOptions}
                  register={form.register(`percursos.${index}.ufPercurso`)}
                  errorsMessage={form.formState.errors.percursos?.[index]?.ufPercurso}
                />
              </Col>
              <Col xs={3} sm={2} md={2} className="text-end">
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={() => remove(index)}
                >
                  Remover
                </Button>
              </Col>
            </Row>
          </div>
        ))
      )}

      <WizardFooter onVoltar={handleVoltar} />
    </Form>
  );
};

export default MDFeCadastroPercursoView;
